import React from 'react';

import '../icon-component.scss';

const InspirationComponent = () => (
  <svg className="icon-component" viewBox="0 0 14 24">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1.000000, 0.000000)">
        <path
          d="M8,1.5 C6.3847749,1.5236939 4.84513837,2.18815379 3.71988243,3.34716741 C2.59462649,4.50618103 1.97595334,6.06478012 2,7.68 C1.93238283,9.59826963 2.65544231,11.4601478 4,12.83 C5.04986061,14.1930749 5.73786652,15.7995687 6,17.5 L10,17.5 C10.2621335,15.7995687 10.9501394,14.1930749 12,12.83 C13.3445577,11.4601478 14.0676172,9.59826963 14,7.68 C14.0240467,6.06478012 13.4053735,4.50618103 12.2801176,3.34716741 C11.1548616,2.18815379 9.6152251,1.5236939 8,1.5 L8,1.5 Z"
          className="icon-component--none"
        />
        <path
          className="icon-component--no-stroke"
          d="M15,7.64 C15.0000001,5.13914084 13.6658076,2.82825165 11.5,1.57782205 C9.33419248,0.327392453 6.66580752,0.327392453 4.49999996,1.57782205 C2.3341924,2.82825165 0.999999947,5.13914084 1,7.64 C0.92724043,9.82199607 1.74275512,11.9401692 3.26,13.51 C4.17162869,14.7259127 4.76927917,16.1479087 5,17.65 C5.07476942,18.1430381 5.50135663,18.5056372 6,18.5 L10,18.5 C10.501932,18.5049401 10.9297504,18.1370163 11,17.64 C11.232299,16.1414055 11.8298749,14.7230213 12.74,13.51 C14.2572449,11.9401692 15.0727596,9.82199607 15,7.64 L15,7.64 Z M12,12.84 C10.9501394,14.2030749 10.2621335,15.8095687 10,17.51 L6,17.51 C5.73786652,15.8095687 5.04986061,14.2030749 4,12.84 C2.65544231,11.4701478 1.93238283,9.60826963 2,7.69 C2,4.3762915 4.6862915,1.69 8,1.69 C11.3137085,1.69 14,4.3762915 14,7.69 C14.0648491,9.60483972 13.3419965,11.462571 12,12.83 L12,12.84 Z"
        />
        <path
          className="icon-component--no-stroke"
          d="M9.75,19.5 L6.25,19.5 C5.97385763,19.5 5.75,19.7238576 5.75,20 C5.75,20.2761424 5.97385763,20.5 6.25,20.5 L9.75,20.5 C10.0261424,20.5 10.25,20.2761424 10.25,20 C10.25,19.7238576 10.0261424,19.5 9.75,19.5 L9.75,19.5 Z"
        />
        <path
          className="icon-component--no-stroke"
          d="M9.25,21 L6.75,21 C6.47385763,21 6.25,21.2238576 6.25,21.5 C6.25,21.7761424 6.47385763,22 6.75,22 L9.25,22 C9.52614237,22 9.75,21.7761424 9.75,21.5 C9.75,21.2238576 9.52614237,21 9.25,21 L9.25,21 Z"
        />
        <path
          className="icon-component--no-stroke"
          d="M8.25,22.5 L7.75,22.5 C7.47385763,22.5 7.25,22.7238576 7.25,23 C7.25,23.2761424 7.47385763,23.5 7.75,23.5 L8.25,23.5 C8.52614237,23.5 8.75,23.2761424 8.75,23 C8.75,22.7238576 8.52614237,22.5 8.25,22.5 L8.25,22.5 Z"
        />
      </g>
    </g>
  </svg>
);

InspirationComponent.displayName = 'InspirationIcon';

export default InspirationComponent;
